// Page-size limits for the two RulesTab views. Pipeline view bucketed by
// stage needs every rule in one fetch (otherwise stages off the first page
// silently appear empty); table view uses the table's pagination control.
export const TABLE_PAGE_LIMIT = 20
export const PIPELINE_PAGE_LIMIT = 200

export type RulesViewMode = 'table' | 'pipeline'

export type PageInfoLike = {
  limit: number
  offset: number
}

const PIPELINE_PAGE_INFO: PageInfoLike = {
  limit: PIPELINE_PAGE_LIMIT,
  offset: 0,
}

// Single source of truth for "what pageInfo should the GET_AUTOMATED_RULES
// query use right now?". The previous bug was that the initial useQuery
// hardcoded the table limit while every refetch path used the conditional
// — so a pipeline-default page returned only 20 of N rules and any stage
// whose rules sorted past row 20 looked empty.
//
// Callers pass the table-mode pageInfo they care about: page 1 reset
// (`{ limit: TABLE_PAGE_LIMIT, offset: 0 }`) for fresh fetches, or the
// user's current pagination for refetches that should preserve position.
export const resolveRulesPageInfo = (
  viewMode: RulesViewMode,
  tablePageInfo: PageInfoLike
): PageInfoLike => (viewMode === 'pipeline' ? PIPELINE_PAGE_INFO : tablePageInfo)
